import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player/lazy";

export default function VideojsPage(props) {
  const [videoSrc, setVideoSrc] = useState(props.src);
  useEffect(() => {
    if (props.src) {
      setVideoSrc(props.src);
    }
  }, [props.src]);

  return props.secondaryPlayer ? (
    <div style={{ marginTop: "0px" }}>
      <ReactPlayer
        url={videoSrc}
        loop={true}
        controls={true}
        height={props.height}
        width={props.width}
        autoplay={true}
        playbackRate={props.playbackRate ? props.playbackRate : 4}
        playing={false}
        muted={true}
      />
    </div>
  ) : (
    <div style={{ marginTop: "0px" }}>
      <ReactPlayer
        loop={true}
        controls={true}
        url={videoSrc}
        height={props.height}
        width={props.width}
        playbackRate={props.playbackRate ? props.playbackRate : 4}
        playing={false}
        muted={true}
      />
    </div>
  );
}
